/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ zalo_error: NonNullable<unknown> }} Error_Zalo_Refresh_FailedInputs */

const vi_error_zalo_refresh_failed = /** @type {(inputs: Error_Zalo_Refresh_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zalo chưa làm mới được token (mã lỗi ${i?.zalo_error}). Token hiện tại vẫn dùng được tới khi hết hạn; thử lại sau ít phút.`)
};

/**

* @param {Error_Zalo_Refresh_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zalo_refresh_failed = /** @type {((inputs: Error_Zalo_Refresh_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zalo_Refresh_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zalo_refresh_failed(inputs)
});